/* tslint:disable */
/* eslint-disable */
// Shared OpenAPI support generated by `npm run apis:all`. Do not edit manually.
import { mapValues } from '../runtime';
import type { ProtobufAny } from './ProtobufAny';
import {
  ProtobufAnyFromJSON,
  ProtobufAnyFromJSONTyped,
  ProtobufAnyToJSON,
  ProtobufAnyToJSONTyped,
} from './ProtobufAny';

export interface GoogleRpcStatus {
  code?: number;
  message?: string;
  details?: Array<ProtobufAny>;
}

export function instanceOfGoogleRpcStatus(value: object): value is GoogleRpcStatus {
  return true;
}

export function GoogleRpcStatusFromJSON(json: any): GoogleRpcStatus {
  return GoogleRpcStatusFromJSONTyped(json, false);
}

export function GoogleRpcStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GoogleRpcStatus {
  if (json == null) {
    return json;
  }
  return {
    code: json['code'] == null ? undefined : json['code'],
    message: json['message'] == null ? undefined : json['message'],
    details:
      json['details'] == null
        ? undefined
        : (json['details'] as Array<any>).map(ProtobufAnyFromJSON),
  };
}

export function GoogleRpcStatusToJSON(json: any): GoogleRpcStatus {
  return GoogleRpcStatusToJSONTyped(json, false);
}

export function GoogleRpcStatusToJSONTyped(
  value?: GoogleRpcStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    code: value['code'],
    message: value['message'],
    details:
      value['details'] == null
        ? undefined
        : (value['details'] as Array<any>).map(ProtobufAnyToJSON),
  };
}
